export class ObjectUtils {
    static Clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    static DeepClone(obj) {
        if(obj === null) {
            return obj;
        }

        if(Array.isArray(obj)) {
            return obj.map((x) => ObjectUtils.DeepClone(x));
        } else if (typeof obj === "function") {
            return obj;
        } else if (typeof obj === 'object' && obj !== null) {
            let clone = Object.create(obj.constructor.prototype);

            for(let i in obj) {
                if(obj[i] != null && typeof(obj[i]) == "object") {
                    clone[i] = ObjectUtils.DeepClone(obj[i]);
                } else {
                    clone[i] = obj[i];
                }
            }

            return clone;
        } else {
            return obj;
        }
    }

    static Merge(a, b) {
        return Object.assign(a, b);
    }

    static ReactElementReplacer(key, value) {
        if(key[0] === '_') {
            // React.element has these stupid
            // things that contain circular references
            return;
        }
        return value;
    }

    // deep compare returns false if the objects are different
    static Compare(a, b, replacer) {
        if(
            (a === null && b !== null) ||
            (a !== null && b === null)
        ) {
            return false;
        } else if (a === null && b === null) {
            return true;
        } else {
            return JSON.stringify(a, replacer) === JSON.stringify(b, replacer);
        }
    }

    static BuildQueryString(obj) {
        let ret = [];
        for(let propertyName in obj) {
            if(Array.isArray(obj[propertyName])) {
                for (const value of obj[propertyName]) {
                    ret.push(encodeURIComponent(propertyName) + "[]=" + encodeURIComponent(value));
                }
            } else if(obj[propertyName] != null) {
                ret.push(encodeURIComponent(propertyName) + "=" + encodeURIComponent(obj[propertyName]));
            }
        }
        return ret.join("&");
    }
    
    // from https://stackoverflow.com/a/40552372/385979
    static BuildFormData(object) {
        const formData = new FormData();
        Object.keys(object).forEach(key => formData.append(key, object[key]));
        return formData;
    }

    static IsString(obj) {
        return (typeof obj === 'string' || obj instanceof String);
    }

    static IsJson(json) {
        try {
            if (typeof json === 'object') {
                json = JSON.stringify(json);
            }

            JSON.parse(json);
        } catch (e) {
            return false;
        }

        return true;
    }
    
    static SafeStringify (data) {
        const getCircularReplacer = () => {
            const seen = new WeakSet();
            return (key, value) => {
                if (typeof value === "object" && value !== null) {
                    if (seen.has(value)) {
                        return;
                    }
                    seen.add(value);
                }
                return value;
            };
        };

        return JSON.stringify(data, getCircularReplacer());
    }
    
    // https://stackoverflow.com/a/58429784/385979
    static arrayUniqueByKey = (array, key) => [
        ...new Map(array.filter(Boolean).map(item => [item[key], item])).values()
    ];

    static addModelsIfUnique = (models, identityPropertyName, desiredIds) => {
        const newItems = desiredIds.map(id => ({[identityPropertyName]: id}));
        return this.arrayUniqueByKey([...models, ...newItems], identityPropertyName);
    }
}
